import React from 'react';
import PropTypes from 'prop-types';
import { getMeasureTitleByKey, getMeasureNameByKey } from '../../../utils/shared/measureUtils';
import {
    ALL_MEASURES,
    getBurstMeasureTitleByKey,
    getBurstMeasureNameByKey,
} from '../../../constants/reading/MeasuresConstants';
import { getOffGradeCell } from '../shared/Cells';
import './Cells.scss';
import { createDataTourStep } from '../../../utils/shared/demoModeUtils';

const SkillCell = props => {
    const { measure, withBurstMark, grade, showMeasureName, className } = props;
    return (
        <div
            data-tour-step={createDataTourStep(measure)}
            className={`data-cell skill-cell ${className}`}
        >
            {withBurstMark && <div className="burst-indicator" />}
            <div className="measure-container">
                <strong>
                    {getMeasureTitleByKey(ALL_MEASURES, measure) ||
                        getBurstMeasureTitleByKey(measure)}
                </strong>
                {showMeasureName && (
                    <div className="measure-name">
                        {getMeasureNameByKey(ALL_MEASURES, measure) ||
                            getBurstMeasureNameByKey(measure)}
                        {getOffGradeCell(grade)}
                    </div>
                )}
            </div>
        </div>
    );
};

SkillCell.defaultProps = {
    measure: null,
    withBurstMark: false,
    grade: null,
    showMeasureName: true,
    className: '',
};

SkillCell.propTypes = {
    measure: PropTypes.string,
    withBurstMark: PropTypes.bool,
    grade: PropTypes.string,
    showMeasureName: PropTypes.bool,
    className: PropTypes.string,
};

export default SkillCell;
